import {
  AbsenceType,
  PendingAbsenceRequestToMeQuery,
} from '../../../__generated__/graphql';
import { mapDocumentFile } from '../../../pages/Absences/mappings';
import { mapLoomVideo } from '../../../components/LoomVideo';
import { AbsenceRequest } from '../types';

export const mapApprovalRequests = (
  src: NonNullable<PendingAbsenceRequestToMeQuery['me']['approvalRequests']>,
): AbsenceRequest[] => {
  return src
    .filter((item) => item.absence)
    .map((item) => {
      const absence = item.absence!;
      const isHourly = absence.flair__Type__c === AbsenceType.Hourly;
      const isMultiDay =
        absence.flair__Start_Date__c !== absence.flair__End_Date__c;

      return {
        id: item.Id,
        absenceId: absence.Id,
        absenceApprovalStatus: absence.flair__Approval_Status__c,
        requestApprovalStatus: item.flair__Approval_Status__c ?? null,
        categoryName: absence.flair__Category_Name__c,
        categoryIcon: absence.flair__Category_Icon__c,
        amount: absence.flair__Amount__c,
        workingAmount: absence.flair__Working_Amount__c,
        startDate: absence.flair__Start_Date__c,
        startTime: absence.flair__Start_Time__c,
        startDateHalfDay: absence.flair__Start_Date_Half_Day__c,
        endDate: absence.flair__End_Date__c,
        endTime: absence.flair__End_Time__c,
        endDateHalfDay: absence.flair__End_Date_Half_Day__c,
        type: absence.flair__Type__c,
        requester: {
          id: absence.employee.Id,
          name: absence.employee.Name,
          avatarUrl: absence.employee.avatar?.url,
        },
        approvalRequests: absence.approvalRequests
          ? mapApprovalRequest(absence.approvalRequests)
          : [],
        comment: absence.flair__Comment__c,
        commentsCount: absence.commentsCount,
        createdDate: absence.CreatedDate,
        attachments:
          absence.ContentDocumentLinks__r?.map(mapDocumentFile) ?? [],
        recordId: absence.Id,
        loomVideo: mapLoomVideo(absence.loomVideo),
        isHourly,
        isMultiDay,
        // absence id and extra fields
        extraFields: absence.extraFields,
        Id: absence.Id,
      };
    });
};

const mapApprovalRequest = (
  src: NonNullable<
    NonNullable<
      PendingAbsenceRequestToMeQuery['me']['approvalRequests'][0]['absence']
    >['approvalRequests']
  >,
) => {
  return src
    ? src
        .filter((ar) => ar.approver)
        .map((ar) => ({
          id: ar.Id,
          approvalStatus: ar.flair__Approval_Status__c,
          approverId: ar.flair__Approver__c!,
          approverComment: ar.flair__Approver_Comment__c,
          lastModifiedDate: ar.LastModifiedDate,
          approver: mapApprover(ar.approver),
          relatedId: ar.flair__Related_Id__c,
        }))
    : [];
};

const mapApprover = (
  src: NonNullable<
    PendingAbsenceRequestToMeQuery['me']['approvalRequests']
  >[0]['approver'],
) => ({
  id: src!.Id,
  name: src!.Name,
  firstName: src!.flair__First_Name__c,
  lastName: src!.flair__Last_Name__c,
  avatar: {
    id: src!.avatar?.Id,
    name: src!.avatar?.Name,
    url: src!.avatar?.url,
  },
});
